import {fetchWithToken} from '@hublot-io/core-api/client'
import downloadjs from 'downloadjs'

import config from '../utils/apiUtils'


export const EtiquettesService = {
  getAll(clientId, date) {
    return fetchWithToken(`${config().etiquetteService}/?clientId=${clientId}&date=${date}`, {method: 'GET'})
      .then(response => {
        if (!response.ok) {
          console.error(`Erreur HTTP: ${response.status}`)
          return []
        }
        return response.json()
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des étiquettes:', error)
        return []
      })
  },
  downloadPromo(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/promo.html`
      })
    }).then(response => {
      if (!response.ok) {
        console.error(`Erreur HTTP: ${response.status}`)
        return
      }
      return response.blob()
    })
      .then(file => {
        if (file) {
          downloadjs(file, `${data.title}.pdf`)
        }
      })
      .catch(error => {
        console.error('Erreur lors du téléchargement de la promo:', error)
      })
  }
}
